import { AboutBanner, Apart, SrkCertification, SrkInfrastructure, SrkPartnership, SrkVision, Story } from "./components";

export const AboutComponents = () => {
    return(
        <>
            <AboutBanner/>
            <Story/>
            <Apart/>
            <SrkVision/>
            <SrkInfrastructure/>
            <SrkCertification/>
            <SrkPartnership/>
        </>
    )
};